export default __webpack_public_path__ + "static/providers-back-c490529394a8a3e30b43722ce132c9a6.jpg";